import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'

import { QueryDropdown } from 'basic-components'
import { DropdownService } from 'primary-components'

import getApiConfig from 'api/ApiConfig'

import SharedWithRow from './SharedWithRow'

import { useQueryClient } from '@tanstack/react-query'

import './FirstStep.scss'

const EMPTY_ARRAY = []
const FirstStep = ({ disabled = false, menuPortalTarget = undefined, onAccessChange, onUserCheck, onAddUserChange, onAddUserClose, sharedWith, addUserSelected, selectedUsers }) => {
  const dispatch = useDispatch(),
        getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
        [emailQuery, setEmailQuery] = useState(),
        queryClient = useQueryClient(),
        { fetchNextPage: fetchMoreEmails, isFetching: isFetchingEmails, isFetchingNextPage: isFetchingNextPageEmails, data: emailsFromApi = EMPTY_ARRAY } = DropdownService.useQueryEmails({
          queryClient,
          input: emailQuery,
          getApiConfig: getApiConfigLocal
        })
  return (
    <div className="data-lake__group-dialog__share">
      <div
          className="data-lake__group-dialog__share__dropdown"
          data-testid="user-dropdown"
      >
        <QueryDropdown
            captureMenuScroll
            creatable
            defaultValue={addUserSelected}
            disabled={disabled}
            dynamicHeight
            fetchNextPage={fetchMoreEmails}
            isFetching={isFetchingEmails || isFetchingNextPageEmails}
            menuPortalTarget={menuPortalTarget}
            multi
            name="newShareUsers"
            noError
            onChange={onAddUserChange}
            onInputChange={setEmailQuery}
            onMenuClose={onAddUserClose}
            options={emailsFromApi}
            placeholder="Select users to share with"
            size="large"
            variant="border"
            withSelectAll
        />
      </div>
      <div className="data-lake__group-dialog__share__shared-with">
        {(sharedWith || []).map(({ email, access, dataStart, dataEnd } = {}) => (
            <SharedWithRow
                access={access}
                checked={selectedUsers.findIndex(su => su?.email === email) > -1}
                disabled={disabled}
                email={email}
                key={email + access}
                onAccessChange={onAccessChange}
                onCheck={onUserCheck}
                restricted={dataStart !== undefined || dataEnd !== undefined}
            />
        ))}
      </div>
    </div>
  )
}

FirstStep.propTypes = {
  addUserSelected: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  menuPortalTarget: PropTypes.object,
  onAccessChange: PropTypes.func.isRequired,
  onAddUserChange: PropTypes.func.isRequired,
  onAddUserClose: PropTypes.func.isRequired,
  onUserCheck: PropTypes.func.isRequired,
  selectedUsers: PropTypes.array.isRequired,
  sharedWith: PropTypes.array.isRequired,
}

export default FirstStep
